export const MENU_ITEM_SECTION_KEYS: Record<string, string> = {
  SmartWhitelist: "smartWhitelist",
  "Special Conditions": "specialConditions",
  "Project Details": "projectDetails",
  "Round Details": "roundDetails",
  "Token Utility": "tokenUtility",
  "How to Get Prepared": "howToGetPrepared",
};

const normalizeLabel = (label: string): string =>
  label.replace(/[^\x20-\x7E]/g, "").trim();

export const getSectionKey = (menuItem: string): string | undefined =>
  MENU_ITEM_SECTION_KEYS[normalizeLabel(menuItem)];

export const filterVisibleMenuItems = (
  menuItems: string[],
  hiddenSections?: string[]
): string[] => {
  if (!hiddenSections || hiddenSections.length === 0) return menuItems;
  return menuItems.filter((item) => {
    const key = getSectionKey(item);
    return !key || !hiddenSections.includes(key);
  });
};

export const getDefaultMenuItem = (
  menuItems: string[],
  _ticker?: string
): string =>
  menuItems.includes("Project Details")
    ? "Project Details"
    : menuItems[0] ?? "";
